import api from './api';
import { Driver } from '../types';

export const driversService = {
  getAll: async (isActive?: boolean): Promise<Driver[]> => {
    const params = isActive !== undefined ? { isActive } : {};
    const response = await api.get<Driver[]>('/drivers', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Driver> => {
    const response = await api.get<Driver>(`/drivers/${id}`);
    return response.data;
  },

  create: async (data: Partial<Driver>): Promise<Driver> => {
    const response = await api.post<Driver>('/drivers', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Driver>): Promise<Driver> => {
    const response = await api.patch<Driver>(`/drivers/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/drivers/${id}`);
  },
};
